import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActivePersonItemService {
  private activeComponentSubject = new Subject<any>();

  setActiveComponent(component: any) {
    this.activeComponentSubject.next(component);
  }

  getActiveComponent() {
    return this.activeComponentSubject.asObservable();
  }
}
